import { render, staticRenderFns } from "./Slice--Text.vue?vue&type=template&id=7a516cdc&lang=pug&"
import script from "./Slice--Text.vue?vue&type=script&lang=js&"
export * from "./Slice--Text.vue?vue&type=script&lang=js&"
import style0 from "./Slice--Text.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports